import Login from './Login'
import Home from './Home'
import LoginFailed from './LoginFailed'
import ReportActivityAVG from './ReportActivityAVG'
import PackageMain from './PackageMain'
import testHome from './testHome'
import VGroupShortcuts from './VGroupShortcuts'
import BillingPlan from './BillingPlan'
import Belink from './Belink'
import DashboardBVP from './DashboardBVP'

export default {
  Login,
  Home,
  LoginFailed,
  ReportActivityAVG,
  PackageMain,
  testHome,
  VGroupShortcuts,
  BillingPlan,
  Belink,
  DashboardBVP
}



// WEBPACK FOOTER //
// ./src/components/Core/index.js